import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _preQuery, _postQuery;
import { useState } from 'react';
import { APIStates, ProductStates } from './product-state-machine-types';
import { usePostQueryDecorator } from './use-post-query-decorator';
import { usePreQueryDecorator } from './use-pre-query-decorator';
import { useInvocations } from './invocations/use-invocations';
import { useQuery } from '../query-context';
import { useAppliedFilters } from '../filters';
import { useSearchSessionId } from '../../common/search-session-provider';
import { useFeaturesContext } from '../features-context/features-context';
export var ProductStateMachinePossibleStates = {
  preQuery: (_preQuery = {}, _defineProperty(_preQuery, APIStates.Typing, ProductStates.Invalid), _defineProperty(_preQuery, APIStates.Error, ProductStates.PreQueryError), _defineProperty(_preQuery, APIStates.Loading, ProductStates.PreQueryLoading), _defineProperty(_preQuery, APIStates.NoResult, ProductStates.PreQueryNoResult), _defineProperty(_preQuery, APIStates.Success, ProductStates.PreQuerySuccess), _preQuery),
  postQuery: (_postQuery = {}, _defineProperty(_postQuery, APIStates.Typing, ProductStates.PostQueryTyping), _defineProperty(_postQuery, APIStates.Error, ProductStates.PostQueryError), _defineProperty(_postQuery, APIStates.Loading, ProductStates.PostQueryLoading), _defineProperty(_postQuery, APIStates.NoResult, ProductStates.PostQueryNoResult), _defineProperty(_postQuery, APIStates.Success, ProductStates.PostQuerySuccess), _postQuery)
};
export var useProductStateMachine = function useProductStateMachine(_ref) {
  var _features$quickFind;
  var setPreQueryItems = _ref.setPreQueryItems,
    setPostQueryItems = _ref.setPostQueryItems,
    preQueryItemSupplier = _ref.preQueryItemSupplier,
    postQueryItemSupplier = _ref.postQueryItemSupplier,
    id = _ref.id,
    _ref$isPrefetchingEna = _ref.isPrefetchingEnabled,
    isPrefetchingEnabled = _ref$isPrefetchingEna === void 0 ? false : _ref$isPrefetchingEna,
    _ref$debounceTime = _ref.debounceTime,
    debounceTime = _ref$debounceTime === void 0 ? 250 : _ref$debounceTime,
    onRetry = _ref.onRetry,
    workspaces = _ref.workspaces,
    _ref$isPreQueryFilter = _ref.isPreQueryFiltersEnabled,
    isPreQueryFiltersEnabled = _ref$isPreQueryFilter === void 0 ? false : _ref$isPreQueryFilter;
  var _useQuery = useQuery(),
    query = _useQuery.query,
    queryVersion = _useQuery.queryVersion;
  var searchSessionId = useSearchSessionId();
  var appliedFilters = useAppliedFilters(id);
  var features = useFeaturesContext();

  /**
   * We track the API calls of Post and Pre query separately.
   */
  var _useState = useState(APIStates.Loading),
    _useState2 = _slicedToArray(_useState, 2),
    preQueryAPIState = _useState2[0],
    setPreQueryAPIState = _useState2[1];
  var _useState3 = useState(APIStates.Loading),
    _useState4 = _slicedToArray(_useState3, 2),
    postQueryAPIState = _useState4[0],
    setPostQueryAPIState = _useState4[1];
  var decoratedPreQuerySupplier = usePreQueryDecorator({
    setAPIState: setPreQueryAPIState,
    preQueryItemSupplier: preQueryItemSupplier,
    setState: setPreQueryItems,
    id: id
  });
  var decoratedPostQuerySupplier = usePostQueryDecorator({
    setAPIState: setPostQueryAPIState,
    setState: setPostQueryItems,
    postQueryItemSupplier: postQueryItemSupplier,
    id: id
  });
  var _useInvocations = useInvocations({
      id: id,
      query: query,
      analyticsInfo: {
        queryVersion: queryVersion,
        searchSessionId: searchSessionId
      },
      filters: appliedFilters,
      isPrefetchingEnabled: isPrefetchingEnabled,
      isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
      preQueryItemSupplier: decoratedPreQuerySupplier,
      postQueryItemSupplier: decoratedPostQuerySupplier,
      debounceTime: debounceTime,
      setPostQueryItems: setPostQueryItems,
      onRetry: onRetry,
      setPostQueryAPIState: setPostQueryAPIState,
      workspaces: workspaces
    }),
    updateStateOnRetryPreQuery = _useInvocations.onRetryPreQuery,
    updateStateOnRetryPostQuery = _useInvocations.onRetryPostQuery;
  var state;
  if ((query !== '' || isPreQueryFiltersEnabled && appliedFilters.length) && !(features !== null && features !== void 0 && (_features$quickFind = features.quickFind) !== null && _features$quickFind !== void 0 && _features$quickFind.postQueryDisabled)) {
    state = ProductStateMachinePossibleStates.postQuery[postQueryAPIState];
  } else {
    state = ProductStateMachinePossibleStates.preQuery[preQueryAPIState];
  }
  return {
    state: state,
    onRetryPreQuery: updateStateOnRetryPreQuery,
    onRetryPostQuery: updateStateOnRetryPostQuery
  };
};